import ClassHelper from '../ClassHelper';
import Transport from '../transport/Transport';

class Seat extends ClassHelper {
  constructor({ seats = [], userSeats = [], transport } = {}) {
    super(...arguments);
    this.seats = this.array(seats);
    this.userSeats = this.array(userSeats);
    this.transport = this.ref(transport, Transport);
  }
}

export default Seat;